var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a",
        {
          attrs: { href: "#" },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.showModal.apply(null, arguments)
            }
          }
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { title: "Imagens para tela de Login", "hide-footer": "" },
          model: {
            value: _vm.showDisplay,
            callback: function($$v) {
              _vm.showDisplay = $$v
            },
            expression: "showDisplay"
          }
        },
        [
          _c(
            "b-card",
            [
              _c("b-card-body", [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    !_vm.imageUploaded.avatar
                      ? _c(
                          "div",
                          [
                            _vm.criar
                              ? _c("h2", [_vm._v("Avatar")])
                              : _c("h2", [_vm._v("Escolha um novo avatar")]),
                            _vm._v(" "),
                            _c("b-form-file", {
                              attrs: {
                                placeholder: "Selecione o arquivo",
                                "browse-text": "Procurar"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.onFileChange($event, "avatar")
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _c("div", [
                          _c("img", {
                            staticClass: "avatar-image",
                            attrs: { src: _vm.imageUploaded.avatar }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "mt-3",
                                  attrs: { variant: "danger", size: "sm" },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeImage("avatar")
                                    }
                                  }
                                },
                                [_vm._v("Remover Avatar")]
                              )
                            ],
                            1
                          )
                        ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12" }, [_c("hr")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12" }, [
                    !_vm.imageUploaded.background
                      ? _c(
                          "div",
                          [
                            _vm.criar
                              ? _c("h2", [_vm._v("Background")])
                              : _c("h2", [
                                  _vm._v("Escolha um novo Background")
                                ]),
                            _vm._v(" "),
                            _c("b-form-file", {
                              attrs: {
                                placeholder: "Selecione o arquivo",
                                "browse-text": "Procurar"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.onFileChange($event, "background")
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _c(
                          "div",
                          [
                            _c("img", {
                              staticClass: "background-image",
                              attrs: { src: _vm.imageUploaded.background }
                            }),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "mt-3",
                                attrs: { variant: "danger", size: "sm" },
                                on: {
                                  click: function($event) {
                                    return _vm.removeImage("background")
                                  }
                                }
                              },
                              [_vm._v("Remover Background")]
                            )
                          ],
                          1
                        )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "b-card-footer",
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right",
                      attrs: { variant: "danger", size: "sm" },
                      on: {
                        click: function($event) {
                          _vm.showDisplay = false
                        }
                      }
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "mr-2 float-right",
                      attrs: { variant: "primary", size: "sm" },
                      on: { click: _vm.save }
                    },
                    [_vm._v("Salvar")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d65069e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d65069e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor/Home/CustomLoginPage.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1d65069e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor/Home/CustomLoginPage.vue
// module chunks = 2